import { AnimatePresence, LayoutGroup, motion } from "framer-motion";
import { memo } from "react";
import IconButton from "../components/IconButton.tsx";
import Separator from "../components/Separator.tsx";
import "./data-display.css";

interface CarouselProps {
	images: { url: string; type: string }[];
	currentIndex: number;
	onSelectImage: (index: number) => void;
	handleNext: () => void;
	handlePrev: () => void;
	onRemoveImage?: (index: number) => void;
}

function Carousel({
	images,
	currentIndex,
	onSelectImage,
	handleNext,
	handlePrev,
	onRemoveImage,
}: CarouselProps) {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
			className="core-carousel-container"
		>
			<IconButton
				backgroundColor="#878787"
				icon="ChevronLeft"
				onClick={handlePrev}
				size="lg"
				disabled={currentIndex === 0}
			/>
			<Separator direction="horizontal" size="md" />
			<LayoutGroup>
				<AnimatePresence mode="wait">
					<motion.div layout className="core-carousel-content">
						<div key={images[currentIndex].url} className="core-carousel-item">
							{images[currentIndex].type.startsWith("image/") && (
								<motion.img
									key={images[currentIndex].url}
									initial={{ opacity: 0 }}
									animate={{ opacity: 1 }}
									exit={{ opacity: 0 }}
									transition={{ duration: 0.3 }}
									whileHover={{ scale: 1.05 }}
									whileTap={{ scale: 0.95 }}
									onClick={() => onSelectImage(currentIndex)}
									src={images[currentIndex].url}
									alt={`Preview ${currentIndex}`}
									style={{
										cursor: "pointer",
									}}
								/>
							)}
							{images[currentIndex].type === "application/pdf" && (
								<embed
									src={images[currentIndex].url}
									type="application/pdf"
									width="100%"
									height="100%"
									style={{ borderRadius: 8 }}
								/>
							)}
						</div>
						<Separator size="md" />
						<motion.div layout>
							<IconButton
								icon="Trash"
								size="lg"
								onClick={() => onRemoveImage && onRemoveImage(currentIndex)}
								backgroundColor="#ff4d4f"
								hoverColor="#ff7875"
							/>
						</motion.div>
					</motion.div>
				</AnimatePresence>
			</LayoutGroup>
			<Separator direction="horizontal" size="md" />
			<IconButton
				backgroundColor="#878787"
				icon="ChevronRight"
				onClick={handleNext}
				size="lg"
				disabled={currentIndex === images.length - 1}
			/>
		</motion.div>
	);
}

export default memo(Carousel);
